import {IPlatformApiProvider} from '@shared/services/platform-api-provider';

export class GemsHistoryApiProvider implements IPlatformApiProvider {
  getApi(url: string): string {
    if (url.startsWith('/gems/history')) {
      return 'FileStoreApi';
    }
    return '';
  }
}
